import { site } from './site';

export const stats = [
  { value: '1997', label: 'Established' },
  { value: '29', suffix: ' yrs', label: 'In the trade' },
  { value: '12', label: 'Collections' },
  { value: '916', label: 'BIS Hallmark + HUID' },
];

export const pillars = [
  {
    title: 'BIS Hallmarked with HUID',
    body: 'Every gold ornament carries the BIS hallmark and its own six-digit HUID, laser-marked on the piece — so you can verify the purity yourself on the BIS CARE app.',
  },
  {
    title: 'One honest price',
    body: 'Every piece is quoted the same way to everybody who walks in. No two-tier pricing, no negotiating theatre.',
  },
  {
    title: 'Transparent making charges',
    body: 'Making charges are quoted before you decide — never discovered at the bill.',
  },
  {
    title: 'Made to your measure',
    body: 'Bring a photograph, an heirloom or a rough sketch. Our karigars work to it.',
  },
];

export const services = [
  { title: 'Bridal consultation', body: 'A private sitting to build the full trousseau — sets matched across ceremonies, budget mapped upfront.' },
  { title: 'Custom & bespoke orders', body: 'Design from a reference or from scratch. CAD or hand-sketch, then cast, set and finished in-house.' },
  { title: 'Old gold exchange', body: 'Fair, transparent valuation of old ornaments against new purchases.' },
  { title: 'Repair & re-polish', body: 'Restringing, rhodium, re-polish and structural repair on antique and diamond pieces.' },
  { title: 'Valuation & documentation', body: 'Written valuation and full documentation for insurance or family records.' },
  { title: 'Hallmarking & certification', body: 'BIS hallmarking with a unique HUID on every gold ornament, and lab certification available on diamond and solitaire pieces.' },
];

export const faqs = [
  {
    q: 'Do I need an appointment to visit?',
    a: `No — walk in on any day we are open. For a full bridal sitting it helps to call ahead on ${site.phoneDisplay} so we can keep pieces aside and give you a quiet counter.`,
  },
  {
    q: 'Is your gold BIS hallmarked with a HUID?',
    a: 'Yes. Every gold ornament we sell carries the BIS hallmark along with its own six-digit HUID (Hallmark Unique Identification) laser-marked on the piece. You can enter that HUID in the BIS CARE app and confirm the purity for yourself before you pay.',
  },
  {
    q: 'Can I get something made to my own design?',
    a: 'Yes. Bring a photograph, an old family piece or a rough sketch. Our karigars work from references regularly, and we will confirm weight and cost before beginning.',
  },
  {
    q: 'Do you take old gold in exchange?',
    a: 'We do. Old ornaments are weighed and valued transparently in front of you and adjusted against your new purchase.',
  },
  {
    q: 'What are your making charges?',
    a: `Making charges vary by category and weight, and we quote them before you commit. We also run seasonal offers — the current one is ${site.offer.headline.toLowerCase()}. Call ${site.phoneDisplay} for today's rate.`,
  },
  {
    q: 'Can I see the collection before visiting?',
    a: 'Yes. Browse the collections here, then send us the pieces you like on WhatsApp — we will keep them aside for your visit and tell you what else has just come in.',
  },
];

export const testimonials = [
  {
    quote:
      'We came in for one bridal set and ended up doing the whole trousseau here. They matched pieces across four functions and never once pushed us above what we said we could spend.',
    name: 'Bridal client',
    meta: 'Ahmedabad',
  },
  {
    quote:
      'I went to four shops before this one. Here they showed me the weight, the hallmark and the making charge before I had even decided. That is why we came back for my sister.',
    name: 'Returning customer',
    meta: 'Ahmedabad',
  },
  {
    quote:
      'They made a mangalsutra from my mother-in-law’s old chain. Same design, better finish, and they showed me the weight at every step.',
    name: 'Custom order client',
    meta: 'Sola, Ahmedabad',
  },
];

export const aboutStory = [
  'Pramukh Jewellers opened in 1997 with a simple working rule: buy right, make it properly, and quote the same honest number to everybody who walks in.',
  'Nearly three decades on, that rule still runs the shop. Antique, bridal, polki and diamond lines are chosen piece by piece and finished to our own standard before they ever reach the case at our Science City Road showroom.',
  'The work itself is old-fashioned. Nakashi in matte 22K. Kundan set by hand. Green meena enamel fired in small batches. Temple panels struck in high relief so Lakshmi still reads clearly at arm’s length. Our karigars work from sketches, photographs and, often enough, from a piece a family already owns and wants remade.',
  'What we are actually selling is confidence — hallmarked purity, making charges quoted before you decide, and a design record kept on file so a re-order two years from now still matches.',
];

export const milestones = [
  { year: '1997', title: 'The firm opens', body: 'Pramukh Jewellers opens its doors in Ahmedabad with a small case of antique and traditional gold.' },
  { year: '2000s', title: 'The antique line finds its following', body: 'Word spreads across Gujarat as the antique and temple work builds a name of its own.' },
  { year: '2010s', title: 'Diamond & polki added', body: 'Certified diamond and polki lines join the range alongside traditional gold.' },
  { year: 'Today', title: 'Science City Road showroom', body: 'A full showroom at Fortune Business Hub, Sola — the complete range on one floor.' },
];
